import { clientKit, FeatureFlags } from '@nxte-nl/feature-flags-client-kit';

import { defaultFeatureToggles } from '../../constants/featureToggle';
import {
  FEATURE_TOGGLES_ENVIRONMENT_FOLDER,
  FEATURE_TOGGLES_PACKAGE_FOLDER,
  FEATURE_TOGGLES_TOKEN,
} from '../../constants/featureToggle';
import { FeatureToggleValues } from '../../types/FeatureToggles';

export const featureToggleUtils = {
  async getFeatureTogglesFromStoryblok(ccid: string): Promise<FeatureToggleValues> {
    const {
      getValues,
      mergeValues,
    } = clientKit.createClient<FeatureFlags>({
      environmentFolder: FEATURE_TOGGLES_ENVIRONMENT_FOLDER,
      packageFolder: FEATURE_TOGGLES_PACKAGE_FOLDER,
      token: FEATURE_TOGGLES_TOKEN,
    });

    const values = await getValues();

    const featureFlagsRecord = mergeValues({
      data: values || null,
      userIdentifier: ccid,
    });

    const result: FeatureToggleValues = { ...defaultFeatureToggles };

    if (featureFlagsRecord !== null) {
      const featureToggleKeys = Object.keys(result) as Array<keyof FeatureToggleValues>;

      for (const featureToggleKey of featureToggleKeys) {
        result[featureToggleKey] =
          featureFlagsRecord[featureToggleKey] || defaultFeatureToggles[featureToggleKey];
      }
    }

    return result;
  },
};
